import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      navbar: {
        home: 'Home',
        services: 'Services',
        testimonials: 'Testimonials',
        contact: 'Contact',
        getStarted: 'Get Started',
        contactUs: 'Contact Us',
        language: 'Language',
        english: 'English',
        chinese: '中文',
      },
      hero: {
        heading: 'Fastest way to secure your\n Visa Appointments',
        subheading: 'Get your visa slot in just 1 week, with our instant visa notification service',
        description:
          'Visa Slot monitors visa centers(UAE, UK) every 3 seconds and instantly alerts you when new appointments open.\nNo more refreshing websites — just subscribe and get notified on Telegram.\nNeed help with your documents? Talk to our agent!',
        subscribe: 'Subscribe Now',
      },
      painPoints: {
        heading: 'How visa slot was born',
        text: `We understand your struggle to get your visa.\n\nWe wanted to travel to Europe with our family and friends — but applying for a Schengen visa was painful.\n\nYou never know when appointments will open. You refresh the VFS website again and again, hoping that at some point, the miracle will happen.\n\nSometimes, you just give up on the trip altogether — not because you don't want to, but because you can't even start to apply.\n\nIf that's you — we built Visa Slot for you.`,
      },
      notificationService: {
        title: '✉️Appointment Notification Service',
        description:
          'Receive 24/7 instant telegram notification for every available Schengen Visa appointment slot.\nWe monitor visa center website every 3 seconds to increase your success.',
        coverageTitle: '🌍 Country Coverage',
        uaeHeading: '🇦🇪 UAE (VFS Dubai & Abu Dhabi): 12 Countries',
        ukHeading: '🇬🇧 UK (VFS London): 23 Countries',
        priceTitle: '👛Price',
        priceDescription:
          'UAE (VFS Dubai & Abu Dhabi): 150AED\nUK (VFS London): £35\n\nfor 10days notifications of all countries above in your region\n(Our user normally secure their appointments in 1 week!*)',
        subscribe: 'Subscribe Now',
        disclaimer:
          '* We are dedicated to providing you with the latest notifications for Schengen visa appointment as soon as possible. However, we do not make the appointment on your behalf, as the process requires entering a lot of personal information.\n\nOur bot is designed to significantly increase your chances of securing the nearest appointment, but we cannot guarantee success. Thank you for your understanding and support!',
      },
      keyBenefits: {
        feature1Title: 'Fastest Booking with real time notifications',
        feature1Description: `We know getting a Schengen visa slot for your trip to Europe is a headache - sometimes taking up to 2-3 months to find a slot\n🕛Visa Slot Bot refreshes every 3 seconds and monitors 24/7\n👏Our average users book their appointment only in just 1 week*! (Not guaranteed)`,
        feature2Title: 'Largest Coverage with the most popular EU countries',
        feature2Description: `12+ EU countries for both UAE(Dubai / Abu Dhabi)\n* You can apply from Abu Dhabi visa center even if you live in Dubai, this gives you a better chance to secure the slot!\n\n20+ EU countries for UK(London)`,
        feature3Title: 'Cheapest among all the options',
        feature3Description: `Our Visa Slot Bot is 10x cheaper than other Schengen visa agencies\nVisa Slot Bot: 150 AED for all countries (for 10 days notification)\nVS.\nOther Schengen visa agencies: 1300~ AED\nOther Visa center bots: 200~ AED only for one country`,
      },
      cta: {
        heading: "Don't miss out on your Schengen Visa appointment slot!",
        content: `50~ Travelers Successfully Secured Their Visa Appointments every Week\n– Join Them Now!`,
        subscribe: 'Subscribe Now',
      },
      stepss: {
        title: 'How to start',
        subtitle: 'Simple 3 steps to start your visa notifications service, and enjoy your travel!',
        signUp: 'Sign Up Now',
        step1Title: 'Sign up telegram account and subscribe to our service',
        step1Description:
          'Create a telegram account and subscribe to our service by following the telegram account instructions.',
        step2Title: 'Receive instant notifications',
        step2Description:
          'Get notified via Telegram as soon as a Schengen Visa appointment slot becomes available in UAE or UK.',
        step3Title: 'Book your appointment',
        step3Description:
          'Act quickly to secure the available appointment slot through the respective VFS center. (Remember to sign up to the vfs website first so that you can book as quick as possible)',
      },
      documentationService: {
        title: '✍️Documentation service',
        description: `Too troublesome to apply for visa yourself?\nWe offer one-stop service, that help you prepare your documents, book appointments and follow-ups.\n\nContact us for the details`,
        contact: 'Contact Us',
      },
      testimonial: {
        heading: '😄 Loved by our users',
        author1Name: 'John Smith',
        author1Position: 'Travel Enthusiast',
        review1:
          'I was able to secure a last-minute visa appointment thanks to this amazing service. Highly recommended!',
        author2Name: 'Emily Zhang',
        author2Position: 'Frequent Traveler',
        review2: 'The instant notifications saved me so much time and hassle. Great value for money!',
        author3Name: 'Ahmed Khan',
        author3Position: 'Business Professional',
        review3: 'I was skeptical at first, but this service exceeded my expectations. Will definitely use it again.',
        author4Name: 'Rajesh Patel',
        author4Position: 'Tourism Blogger',
        review4: "The largest coverage of appointment slots compared to other services I've tried. Impressive!",
      },
      contact: {
        heading: 'Contact Us',
        content: 'Have a question or need support? Reach out to us!',
        action: 'Contact Us',
      },
      footer: {
        privacy: 'Privacy Policy',
        terms: 'Terms and Conditions',
      },
      countries: {
        france: 'France',
        netherlands: 'Netherlands',
        portugal: 'Portugal',
        italy: 'Italy',
        hungary: 'Hungary',
        switzerland: 'Switzerland',
        austria: 'Austria',
        czechia: 'Czechia',
        greece: 'Greece',
        finland: 'Finland',
        sweden: 'Sweden',
        norway: 'Norway',
        spain: 'Spain',
        germany: 'Germany',
        belgium: 'Belgium',
        bulgaria: 'Bulgaria',
        malta: 'Malta',
        iceland: 'Iceland',
        denmark: 'Denmark',
        lithuania: 'Lithuania',
        cyprus: 'Cyprus',
        slovenia: 'Slovenia',
        estonia: 'Estonia',
        croatia: 'Croatia',
        latvia: 'Latvia',
      },
    },
  },
  zh: {
    translation: {
      navbar: {
        home: '首页',
        services: '服务',
        testimonials: '客户评价',
        contact: '联系我们',
        getStarted: '开始使用',
        contactUs: '联系我们',
        language: '语言',
        english: 'English',
        chinese: '中文',
      },
      hero: {
        heading: '最快速的方式预约签证\n',
        subheading: '只需一周即可获得签证名额，享受我们的即时签证通知服务',
        description:
          'Visa Slot 每3秒监控一次签证中心（阿联酋、英国），一有新名额立即通知您。\n无需再频繁刷新网站——只需订阅，即可通过Telegram收到通知。\n需要文件协助？请联系我们的客服！',
        subscribe: '立即订阅',
      },
      painPoints: {
        heading: 'Visa Slot 的诞生',
        text: `我们理解你申请签证的痛苦。\n\n我们也曾想和家人朋友一起去欧洲旅行——但申根签证的申请过程非常繁琐。\n\n你永远不知道什么时候会有名额。你一次次刷新VFS网站，希望奇迹出现。\n\n有时你甚至会放弃旅行——不是因为不想去，而是因为连申请都无法开始。\n\n如果你有同感——Visa Slot 就是为你而生。`,
      },
      notificationService: {
        title: '✉️预约通知服务',
        description:
          '全天候24/7通过Telegram推送每一个可用的申根签证预约名额。\n我们每3秒监控一次签证中心网站，极大提升你的成功率。',
        coverageTitle: '🌍 覆盖国家',
        uaeHeading: '🇦🇪 阿联酋 (迪拜&阿布扎比VFS): 12个国家',
        ukHeading: '🇬🇧 英国 (伦敦VFS): 23个国家',
        priceTitle: '👛价格',
        priceDescription:
          '阿联酋(迪拜&阿布扎比): 150迪拉姆\n英国(伦敦): £35\n\n10天内通知你所在地区所有国家的名额\n（我们的用户通常1周内就能预约到！*）',
        subscribe: '立即订阅',
        disclaimer:
          '* 我们致力于第一时间为您推送申根签证预约名额，但不会代为预约，因需填写大量个人信息。\n\n我们的机器人极大提升您预约到最近名额的概率，但不保证一定成功。感谢您的理解与支持！',
      },
      keyBenefits: {
        feature1Title: '最快速预约，实时通知',
        feature1Description: `我们知道申请申根签证名额很头疼——有时要等2-3个月才能抢到。\n🕛Visa Slot Bot每3秒刷新一次，全天候监控。\n👏我们的用户通常1周内就能预约到！（不保证）`,
        feature2Title: '覆盖最多热门欧盟国家',
        feature2Description: `阿联酋（迪拜/阿布扎比）支持12+欧盟国家\n* 即使你住在迪拜，也可以去阿布扎比签证中心申请，成功率更高！\n\n英国（伦敦）支持20+欧盟国家`,
        feature3Title: '全网最低价',
        feature3Description: `Visa Slot Bot比其他申根签证中介便宜10倍\nVisa Slot Bot：150迪拉姆，涵盖所有国家（10天通知）\nVS.\n其他申根签证中介：1300~迪拉姆\n其他签证中心机器人：200~迪拉姆，仅限一个国家`,
      },
      cta: {
        heading: '不要错过申根签证预约名额！',
        content: `每周有50+旅行者成功预约到签证名额\n– 现在就加入他们吧！`,
        subscribe: '立即订阅',
      },
      stepss: {
        title: '如何开始',
        subtitle: '只需3步，开启签证预约通知，畅享旅行！',
        signUp: '立即注册',
        step1Title: '注册Telegram账号并订阅我们的服务',
        step1Description: '创建Telegram账号并根据指引订阅我们的服务。',
        step2Title: '接收即时通知',
        step2Description: '一旦阿联酋或英国有申根签证名额，您会第一时间收到Telegram通知。',
        step3Title: '预约签证名额',
        step3Description: '请尽快通过VFS中心预约名额。（记得提前注册VFS网站账号，以便更快预约）',
      },
      documentationService: {
        title: '✍️文档服务',
        description: `自己申请签证太麻烦？\n我们提供一站式服务，帮您准备材料、预约名额、全程跟进。\n\n详情请联系我们`,
        contact: '联系我们',
      },
      contact: {
        heading: '联系我们',
        content: '有任何问题或需要帮助？欢迎联系我们！',
        action: '联系我们',
      },
      footer: {
        privacy: '隐私政策',
        terms: '条款与条件',
      },
      countries: {
        france: '法国',
        netherlands: '荷兰',
        portugal: '葡萄牙',
        italy: '意大利',
        hungary: '匈牙利',
        switzerland: '瑞士',
        austria: '奥地利',
        czechia: '捷克',
        greece: '希腊',
        finland: '芬兰',
        sweden: '瑞典',
        norway: '挪威',
        spain: '西班牙',
        germany: '德国',
        belgium: '比利时',
        bulgaria: '保加利亚',
        malta: '马耳他',
        iceland: '冰岛',
        denmark: '丹麦',
        lithuania: '立陶宛',
        cyprus: '塞浦路斯',
        slovenia: '斯洛文尼亚',
        estonia: '爱沙尼亚',
        croatia: '克罗地亚',
        latvia: '拉脱维亚',
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
